
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.448 4.05L10.35 1.952a1.2 1.2 0 00-.847-.352H4.4c-.662.002-1.2.54-1.2 1.202V13.2a1.2 1.2 0 001.2 1.2h7.2a1.2 1.2 0 001.2-1.2V4.9c0-.318-.127-.626-.352-.85zm-.945.752H9.6V2.9l1.903 1.902zM4.4 13.2V2.802h4v2.6c0 .332.268.6.6.6h2.6V13.2H4.4zm5.3-5.999h-.72c-.11 0-.21.06-.262.158-.45.827-.555 1.06-.715 1.442-.348-.727-.173-.432-.715-1.442a.301.301 0 00-.265-.158H6.3a.3.3 0 00-.26.45l1.158 1.95-1.158 1.95c-.117.2.028.45.26.45h.723c.11 0 .21-.06.262-.158.543-1 .575-1.125.715-1.442.373.755.148.397.715 1.442A.301.301 0 008.98 12h.72a.3.3 0 00.26-.45L8.8 9.6c.018-.027.758-1.261 1.158-1.949a.299.299 0 00-.258-.45z","fill":"#525F7F"}})])
          )
        }
      }
    